import type { StatusColor } from '@repo/types';
import c from 'classnames';
import { FC } from 'react';
import { Icon, IconName } from '../Icon';
import { Typography } from '../Typography/Typography';
import styles from './StatusPill.module.css';

export interface StatusPillProps {
  status: string;
  color: StatusColor;
  /** Takes the dot's place, for statuses the design marks with a glyph. */
  iconName?: IconName;
  hideDot?: boolean;
  onClick?: () => void;
}

export const StatusPill: FC<StatusPillProps> = ({
  status,
  color,
  iconName,
  hideDot,
  onClick,
}) => {
  return (
    <div
      className={c(
        styles.statusPill,
        styles[color],
        onClick && styles.clickable,
      )}
      onClick={onClick}
    >
      {iconName ? (
        <Icon name={iconName} size='s' />
      ) : !hideDot ? (
        <div className={c(styles.dot, styles[color])} />
      ) : null}
      <Typography variant='label'>{status}</Typography>
    </div>
  );
};
